import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { Clock } from "lucide-react";

/** Jul-2026 (User-Wunsch): Ein-/Ausstempeln dauerhaft klein im Header —
 *  nicht nur als Erinnerung. Nutzt den verknüpften Mitarbeiter-Datensatz. */
export const HeaderTimeClock = () => {
    const [state, setState] = useState(null);
    const [busy, setBusy] = useState(false);
    const [, setTick] = useState(0);

    const load = useCallback(async () => {
        try {
            const { data } = await api.get("/me/time/punch-state");
            setState(data?.linked ? data : null);
        } catch { setState(null); }
    }, []);
    useEffect(() => {
        load();
        const t = setInterval(load, 60 * 1000);
        return () => clearInterval(t);
    }, [load]);
    useEffect(() => {
        if (!state?.clocked_in) return;
        const t = setInterval(() => setTick((v) => v + 1), 60 * 1000);
        return () => clearInterval(t);
    }, [state?.clocked_in]);

    if (!state) return null;
    const isIn = state.clocked_in;
    // Jul-2026 (User-Wunsch) — eingeplant, aber nicht eingestempelt → animieren.
    const needsPunch = !isIn && state.scheduled_now;
    let since = "";
    if (isIn && state.open_since) {
        const mins = Math.max(0, Math.floor((Date.now() - new Date(state.open_since).getTime()) / 60000));
        since = `${String(Math.floor(mins / 60)).padStart(2, "0")}:${String(mins % 60).padStart(2, "0")}`;
    }
    const punch = async () => {
        setBusy(true);
        try {
            const { data } = await api.post("/me/time/reminder-punch", {});
            toast.success(data.action === "clock_in" ? "Eingestempelt — guten Arbeitstag!" : "Ausgestempelt — Feierabend!");
            await load();
        } catch (e) { toast.error(e.response?.data?.detail || "Stempeln fehlgeschlagen"); }
        setBusy(false);
    };
    return (
        <button
            type="button"
            onClick={punch}
            disabled={busy}
            title={isIn ? `Eingestempelt seit ${since} Std. — klicken zum Ausstempeln` : (needsPunch ? "Du bist heute eingeplant — bitte einstempeln!" : "Klicken zum Einstempeln")}
            className={`inline-flex items-center gap-1.5 h-9 px-2.5 rounded-sm text-[11px] font-bold uppercase tracking-wider transition-colors disabled:opacity-50 ${
                isIn ? "bg-emerald-600 hover:bg-emerald-700 text-white"
                    : needsPunch ? "bg-[#EA580C] hover:bg-[#C2410C] text-white animate-pulse ring-2 ring-amber-300 ring-offset-1"
                        : "bg-[#111827] hover:bg-black text-white"
            }`}
            data-testid="header-time-clock-btn"
        >
            <Clock className={`w-3.5 h-3.5 ${isIn || needsPunch ? "animate-pulse" : ""}`} />
            {isIn ? <>Ausstempeln{since && <span className="font-mono-num normal-case">· {since}</span>}</> : "Einstempeln"}
        </button>
    );
};

export default HeaderTimeClock;
